import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { ToastService } from './../utils/toast.service';

@Injectable()
export class PromptUpdateService {

  constructor(
    private readonly swUpdate: SwUpdate,
    private readonly toasService: ToastService
  ) {

  }
  init(): void {
    this.swUpdate.available.subscribe(() => {
      this.swUpdate.activateUpdate()
      .then(() => {
        this.toasService.showToast(
          'success',
          'pwa.update_service.title',
          'pwa.update_service.body'
        );

        navigator.serviceWorker.getRegistrations()
        .then(
           (registrations: any): any => {
            for (const registration of registrations) {
              registration.update();
            }
          });

        setTimeout(() => { document.location.reload(); }, 5000);
      });
    });
  }
}
